module.exports = __webpack_public_path__ + "img/music-placeholder.917378d4.png";